import React from 'react'
import { money } from '../financial/formatting'
import { count } from './model'

// by_origin. With a buyer selected, the API's lead counts cover only that
// buyer's leads (accepted and rejected come back as 0), so those columns are
// left out rather than shown contradicting the tabs below.
export default function OriginTable({ rows, buyerFiltered }) {
  const sorted = [...(rows || [])].sort((a, b) => b.revenue - a.revenue || b.received - a.received)
  const columns = [
    { key: 'origin', label: 'Origin', render: (r) => r.origin },
    ...(buyerFiltered ? [] : [{ key: 'received', label: 'Received', num: true, render: (r) => count(r.received) }]),
    { key: 'sold', label: 'Sold', num: true, render: (r) => count(r.sold) },
    ...(buyerFiltered ? [] : [
      { key: 'accepted_not_sold', label: 'Accepted, not sold', num: true, render: (r) => count(r.accepted_not_sold) },
      { key: 'rejected', label: 'Rejected', num: true, render: (r) => count(r.rejected) },
    ]),
    { key: 'revenue', label: 'Revenue', num: true, render: (r) => money(r.revenue) },
    { key: 'our_share', label: 'Ours', num: true, swatch: 'var(--share-ours)', render: (r) => money(r.our_share) },
    { key: 'partner_share', label: 'Partners', num: true, swatch: 'var(--share-partner)', render: (r) => money(r.partner_share) },
  ]

  return (
    <section className="card" aria-labelledby="sl-origins-title" style={{ padding: 0, overflow: 'hidden' }}>
      <h2 id="sl-origins-title" style={{ margin: 0, padding: '16px 18px 8px', fontSize: 15, fontWeight: 700 }}>Where leads come from</h2>
      {sorted.length === 0 ? (
        <p style={{ margin: 0, padding: '0 18px 16px', fontSize: 13, color: 'var(--text-muted)' }}>No leads in this range.</p>
      ) : (
        <div className="sl-table-scroll">
          <table className="sl-table">
            <thead>
              <tr>
                {columns.map((c) => (
                  <th key={c.key} className={c.num ? 'sl-num' : undefined}>
                    {c.swatch && <span aria-hidden="true" style={{ display: 'inline-block', width: 8, height: 8, borderRadius: 2, background: c.swatch, marginRight: 5 }} />}
                    {c.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sorted.map((r) => (
                <tr key={r.origin}>
                  {columns.map((c) => <td key={c.key} className={c.num ? 'sl-num' : undefined}>{c.render(r)}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}
